import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import Header from './Header';
import GrievanceReportTable from './GreivanceReportTable';
import axios from 'axios';

const GrievanceReport = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAdminView, setIsAdminView] = useState(false);
    const [grievances, setGrievances] = useState([]);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    // useEffect(() => {
    //     if (props.loginList) {
    //         const loginListFromParent = props.loginList;

    //         const permit = loginListFromParent.some(
    //             (item) =>
    //                 (item.permissionName.includes('Admin Role') &&
    //                     item.permissionType.includes('view')) ||
    //                 (item.permissionName.includes('Grievance') &&
    //                     item.permissionType.includes('view'))
    //         );

    //         if (!permit) {
    //             window.stop();
    //             alert('You have no permissions to access this page.');
    //             window.location = '/';
    //         } else {
    //             setIsLoading(false);
    //         }
    //     }
    // }, [props.loginList]);

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Grievance Report') &&
                        item.permissionType.includes('view'))
            );

            if (permit) {
                setIsAdminView(true);
            }

            if (!permit && props.grievancePermission == 0) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }
        }
    }, [props.loginList, props.grievancePermission]);

    useEffect(() => {
        if (isAdminView) {
            fetchGrievancesAdmin();
        }
        else {
            fetchGrievances();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localStorage.getItem('badgeID'), isAdminView]);

    async function fetchGrievancesAdmin() {
        if (localStorage.getItem('badgeID')) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/grievance/getgrievancelist';
            axios
                .post(url, { userID: 'report' })
                .then((response) => {
                    if (response === undefined) {
                        console.log("Undefined data");
                    }
                    else {
                        for (let i = 0; i < response.data.GrievanceList.length; i++) {
                            if (response.data.GrievanceList[i].grievanceStatusID == 5 && !response.data.GrievanceList[i].validatedByID) {
                                response.data.GrievanceList[i].grievanceStatusName = "Open";
                            }
                            else if (response.data.GrievanceList[i].grievanceStatusID == 5 && response.data.GrievanceList[i].validatedByID) {
                                response.data.GrievanceList[i].grievanceStatusName = "Rejected";
                            }
                            else if (response.data.GrievanceList[i].grievanceStatusID == 6) {
                                response.data.GrievanceList[i].grievanceStatusName = "Validation";
                            }
                        }
                        setGrievances(response.data.GrievanceList.reverse());
                    }
                })
                .catch((err) => console.error(err));
        }
    }

    async function fetchGrievances() {
        if (localStorage.getItem('badgeID')) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/grievance/getgrievancelist';
            axios
                .post(url, { userID: localStorage.getItem('badgeID') })
                .then((response) => {
                    if (response === undefined) {
                        console.log("Undefined data");
                    }
                    else {
                        for (let i = 0; i < response.data.GrievanceList.length; i++) {
                            if (response.data.GrievanceList[i].grievanceStatusID == 5 && !response.data.GrievanceList[i].validatedByID) {
                                response.data.GrievanceList[i].grievanceStatusName = "Open";
                            }
                            else if (response.data.GrievanceList[i].grievanceStatusID == 5 && response.data.GrievanceList[i].validatedByID) {
                                response.data.GrievanceList[i].grievanceStatusName = "Rejected";
                            }
                            else if (response.data.GrievanceList[i].grievanceStatusID == 6) {
                                response.data.GrievanceList[i].grievanceStatusName = "Validation";
                            }
                        }
                        setGrievances(response.data.GrievanceList.reverse());
                    }
                })
                .catch((err) => console.error(err));
        }
    }

    const GrievanceTable = () => {
        return (
            <Fragment>
                {grievances.length > 0 ? (
                    <GrievanceReportTable grievances={grievances} />
                ) : (
                    <div>No grievance to show</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${props.isActive ? 'container is-active' : 'container-fluid'
                            }`}
                    >
                        <Header />
                        <div className='table-wrapper'>
                            <GrievanceTable />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default GrievanceReport;